import {useNavigate  , Navigate, Outlet } from 'react-router-dom';

import axios from 'axios';
import { AXIOS_HOST } from '../config/axios.config';
import { PrivateRoutes, PublicRoutes } from '../routes/routes';
import { useEffect, useRef, useState } from 'react';
import { obtainLocalStorageItem } from '../utilities/localStorage.utility';


const PrivateValidationFragment = <Outlet />;
const PublicValidationFragment = (
  <Navigate replace to={PublicRoutes.LOGIN} />
);


const RoleGuard = ({ rolesPermitidos }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const navigate = useNavigate();
  
    useEffect(() => {
      const checkAuth = async () => {
        try {
          const token = localStorage.getItem("token");
          if (!token) {
            throw new Error("No token found");
          }
          const response = await axios.get(`${AXIOS_HOST}/jwt//rolVerify`, {
            headers: { Authorization: `Bearer ${token} {"roles":[${rolesPermitidos}]}` }
          });
          if (response.status !== 200) {
            throw new Error("Invalid Roles");
          }
          setIsAuthenticated(true);
        } catch (error) {
          console.error(error);
          navigate("/dashboard");
        }
      };
      checkAuth();
    }, [navigate]);
  
    return isAuthenticated ? PrivateValidationFragment : null;
  };
  
  export default RoleGuard;